import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import hydroponic_farm_img from "../../Assets/hydroponic_farm_img.webp";
import "./blog.css";
import "animate.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

function Hydroponic_Farming() {
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowImage(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Container fluid>
      <div className="d-flex justify-content-center">
        <img
          src={hydroponic_farm_img}
          className={`card-img-top img-fluid p-3 rounded animate__animated animate__fadeInDown ${
            showImage ? "show" : ""
          }`}
          style={{ width: "70%" }}
          alt="Hydroponic farming"
        />
      </div>

      <Row className="m-2">
        <Col
          className="p-4 textJustify"
          sm={12}
          md={9}
          xs={12}
          style={{ margin: "auto", fontSize: "1rem", lineHeight: "1.6" }}
          id="content"
        >
          <div
            id="blog1"
            className="border p-3"
            style={{ borderRadius: "10px" }}
          >
            <h1 className="text-center mb-3">
              Hydroponic Farming: The Future of Agriculture
            </h1>
            <p className="pb-3">
              Hydroponic farming is transforming agriculture by introducing a
              more sustainable and technologically advanced way to grow food.
              This innovative method eliminates the need for soil and instead
              uses a nutrient-rich water solution to support plant growth. With
              hydroponic farming, crops grow faster, use less water, and require
              less space—all while producing higher yields.
            </p>

            <h4>What is Hydroponic Farming?</h4>
            <p>
              Hydroponic farming is a cutting-edge agricultural technique where
              plants are grown in a controlled environment without soil.
              Instead, the roots receive nutrients directly from water. This
              sustainable farming method offers numerous advantages, including:
            </p>
            <ul>
              <li>Accelerated plant growth due to direct nutrient delivery.</li>
              <li>Increased crop yield in smaller areas.</li>
              <li>
                Up to 90% water savings compared to traditional agriculture.
              </li>
              <li>
                Adaptability for urban spaces, rooftops, and areas with poor
                soil quality.
              </li>
            </ul>

            <h4>How Hydroponic Farming Works</h4>
            <p>
              Hydroponic systems circulate water enriched with essential
              nutrients directly to plant roots. These systems can be tailored
              to suit different crops and scales, from home gardens to
              commercial greenhouses. The absence of soil means fewer pests,
              less disease, and a cleaner growing environment—ideal for
              producing fresh, organic vegetables in a climate-resilient way.
            </p>

            <h4>Hydroponic Farming and Climate Change</h4>
            <p>
              As climate change continues to disrupt weather patterns,
              hydroponic farming offers a stable, weather-independent food
              production system. Whether facing droughts, floods, or extreme
              heat, hydroponic farms can continue operating indoors, making them
              an essential part of the global climate adaptation strategy.
            </p>

            <h4>Benefits of Hydroponic Farming</h4>
            <ol>
              <li>
                <strong>Water Efficiency:</strong> Uses up to 90% less water.
              </li>
              <li>
                <strong>Land Optimization:</strong> Grow more food in less
                space.
              </li>
              <li>
                <strong>Year-Round Production:</strong> Independent of seasons
                or climate.
              </li>
              <li>
                <strong>Higher Yields:</strong> Maximize productivity per square
                foot.
              </li>
              <li>
                <strong>Reduced Chemicals:</strong> Fewer pesticides and
                herbicides.
              </li>
              <li>
                <strong>Nutrient Control:</strong> Precision feeding for
                healthier crops.
              </li>
              <li>
                <strong>Sustainability:</strong> Supports local, eco-friendly
                farming.
              </li>
            </ol>

            <h4>Why Hydroponic Farming is Essential for India</h4>
            <p>
              In a country like India, where agricultural land is shrinking and
              water scarcity is rising, hydroponic farming presents a scalable
              solution. It supports food security, reduces dependence on
              imports, and creates opportunities for urban farming and
              entrepreneurship.
            </p>

            <h4>Start Hydroponic Farming with RGCPL</h4>
            <p>
              At <strong>Royal Green House Construction (RGCPL)</strong>, we
              provide comprehensive hydroponic farming solutions for beginners
              and commercial growers. Whether you're planning to start a
              small-scale indoor farm or a large commercial hydroponic project,
              our expert team offers customized system designs, setup services,
              and technical support to ensure success.
            </p>

            <a href="http://www.royalgreenhouse.co.in/" target="_blank">
              <h4>Why Choose RGCPL for Your Hydroponic Farming Needs?</h4>
            </a>
            <p>
              Choosing RGCPL means investing in reliable, high-performance
              hydroponic systems tailored to your needs. Our solutions are
              sustainable, scalable, and future-ready. From leafy greens to vine
              crops, we help you grow better with less—less space, less water,
              and less worry.
            </p>

            <p>
              Embrace the future of farming with RGCPL's hydroponic systems and
              be a part of the sustainable agriculture revolution.
            </p>

            <div className="d-flex align-items-center mb-3">
              <FontAwesomeIcon icon={faPhone} className="me-2 text-success" />
              <span>
                Phone:{" "}
                <a
                  href="tel:+919960991166"
                  className="text-primary text-decoration-none"
                >
                  +91-9960-991-166
                </a>
              </span>
            </div>
            <div className="d-flex align-items-center mb-3">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="me-2 text-success"
              />
              <span>
                Email:{" "}
                <a
                  href="mailto:info@royalgreenhouse.co.in"
                  target="_blank"
                  className="text-primary text-decoration-none"
                >
                  info@royalgreenhouse.co.in
                </a>
              </span>
            </div>
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faGlobe} className="me-2 text-success" />
              <span>
                Website:{" "}
                <a
                  href="http://www.royalgreenhouse.co.in/"
                  className="text-primary text-decoration-none"
                >
                  www.royalgreenhouse.co.in
                </a>
              </span>
            </div>

            <p className="pt-3">
              Hydroponic farming is more than a trend—it's a movement toward a
              sustainable, efficient, and climate-proof way of growing food. Get
              started with hydroponic farming today and help build a greener
              tomorrow.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Hydroponic_Farming;
